import {
  Component,
  input,
  InputSignal,
  OnDestroy,
  TemplateRef,
} from '@angular/core';
import { CommonModule } from '@angular/common';
import {
  ControlContainer,
  FormGroupDirective,
  NgControl,
  ReactiveFormsModule,
} from '@angular/forms';
import { ErrorMessageComponent } from '../../../layout/error-message/error-message.component';
import {
  FormInputSelectComponent,
  SelectOption,
} from '../form-input-select.component';
import { ToSelectOptionAttributePipe } from '../../../../pipes/to-select-option-attribute/to-select-option-attribute.pipe';
import { AppendTestIdPipe } from '../../../../pipes/append-test-id/append-test-id.pipe';
import { fromEvent } from 'rxjs';

@Component({
  selector: 'aw-single-select',
  imports: [
    CommonModule,
    ReactiveFormsModule,
    ErrorMessageComponent,
    ToSelectOptionAttributePipe,
    AppendTestIdPipe,
  ],
  viewProviders: [
    {
      provide: ControlContainer,
      useExisting: FormGroupDirective,
    },
  ],
  templateUrl: './single-select.component.html',
  styles: `
    input[type='radio']:checked {
      background-image: radial-gradient(
        circle,
        currentColor 0%,
        currentColor 36%,
        transparent 40%
      );
      background-color: transparent;
      border-color: unset;
    }
  `,
})
export class SingleSelectComponent<T>
  extends FormInputSelectComponent
  implements OnDestroy
{
  public readonly hasBorder: InputSignal<boolean> = input(false);
  public readonly template: InputSignal<TemplateRef<any> | undefined> = input();

  constructor(public override ngControl: NgControl) {
    super(ngControl);
    this.subscription.add(
      fromEvent<
        KeyboardEvent & { target?: { id: string; value: SelectOption } }
      >(document, 'keyup').subscribe(event => {
        const index: number = +event.target?.id?.split('-')[2];
        const isCorrectTarget = event.target?.id === this.id() + '-' + index;
        if (event.key === 'Enter' && isCorrectTarget) {
          event.preventDefault();
          this.selectOption(this.options()[index]);
        }
      })
    );
  }
  
  override ngAfterViewInit(): void {
    if (this.ngControl.value !== null && this.ngControl.value !== '') {
      this.ngControl.control?.markAsTouched();
    }
  }
}
